<template>
	<div class="downloadRemote">
		<Header @getHeaderHeight="getHeaderHeight"></Header>
		<div class="downloadRemote" :style="{ 'padding-top': headerHeight - 1 + 'px' }">
			<div class="spotlight-container">
				<div class="spotlight-content">
					<div class="spotlight-wrap">
						<div class="left">
							<div class="title">
								<img :src="require('@/static/img/mcstore-logo.png')" alt="">
							</div>
							<div class="introduction-text">{{ $t('dowmloadMcstore.mainDesc')}}</div>
							<div class="download-wrap">
								<a href="javascript: void (0)" class="downloadBtn"
									@click="onDowmload">{{ $t('dowmloadMcstore.dowmload')}}</a>
								<div class="text">
									<span>*{{ $t('dowmloadMcstore.text1')}}</span>
									<span class="important-explanation">{{ $t('dowmloadMcstore.text2')}}</span>
								</div>
							</div>
						</div>
						<div class="right">
							<div class="media">
								<LazyImage className="viewport" imagePath="/res/img/icon-mcstore-header.png"></LazyImage>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer />
	</div>
</template>

<script>
	import Header from '../header/index.vue'
	import Footer from '../footer/index.vue'
	export default {
		name: 'downloadRemote',
		components: {
			Header,
			Footer
		},
		data() {
			return {
				headerHeight: '',
				url: ''
			};
		},
		computed: {},
		methods: {
			getHeaderHeight(val) {
				this.headerHeight = val
			},
			onDowmload() {
				const link = document.createElement('a')
				link.href = '/res/download/mcstore.apk'
				document.body.appendChild(link)
				link.click()
				document.body.removeChild(link)
			}
		},
		created() {

		},
		mounted() {

		},
		updated() {},
	}
</script>
<style lang='less' scoped>
	.viewport {
		min-height: 688px;
	}
	.downloadRemote {
		box-sizing: border-box;
	}

	.spotlight-container {
		background: linear-gradient( 180deg, #051412 0%, #051412 70%, #4F797C 100%);
		.spotlight-content {
			max-width: 1280px;
			margin: 0 auto;
			padding: 0 24px;
		}

		.spotlight-wrap {
			padding-top: 32px;
			display: flex;
			align-items: center;
			justify-content: space-between;

			.left {
				width: 50%;
				color: #fff;

				.title {
					font-size: 32px;
					font-family: 'Alibaba PuHuiTi B';
				}

				.introduction-text {
					padding: 28px 0 24px;
					font-size: 18px;
				}

				.note {
					font-size: 14px;
					padding-bottom: 16px;
				}

				.txt {
					color: #0eae6d;
				}

				.download-wrap {
					.downloadBtn {
						display: inline-block;
						padding: 12px 20px;
						background: #1ef8a0;
						border-radius: 48px;
						color: #151515;
					}

					.text {
						padding-top: 14px;

						.important-explanation {
							color: #22b67b;
							font-size: 14px;
						}
					}
				}
			}

			.media {
				img {
					display: block;
					max-width: 100%;
					max-height: 100%;
					object-fit: contain;
					/* 或使用 'contain' 根据需求 */
				}
			}
		}
	}

	.content-title {
		max-width: 1280px;
		margin: 0 auto;
		width: 100%;
		padding: 48px 24px;

		h1,
		h4 {
			text-align: center;
			word-break: break-all;
		}

		h1 {
			font-size: 40px;
			font-family: 'Alibaba PuHuiTi B';
		}

		h4 {
			font-size: 20px;
			font-weight: 400;
		}
	}

	.introduction-wrap {
		.bg {
			background: #EDEDED;
		}

		.introduction-inner {
			padding-top: 40px;

			.left {
				width: 40%;
				color: #151515;

				.title {
					word-break: break-all;
					font-size: 32px;
					font-family: 'Alibaba PuHuiTi B';
				}

				.introduction-text {
					padding: 12px 0 16px;
					font-size: 18px;
				}

				.note {
					font-size: 14px;
					padding-bottom: 16px;
				}

				.txt {
					color: #0eae6d;
				}

				.download-wrap {
					.downloadBtn {
						display: inline-block;
						padding: 12px 20px;
						background: #1ef8a0;
						border-radius: 48px;
						color: #151515;
					}

					.text {
						padding-top: 14px;

						.important-explanation {
							color: #22b67b;
							font-size: 14px;
						}
					}
				}
			}
		}

		.introduction-item {
			padding: 0 24px;
			box-sizing: border-box;
			max-width: 1280px;
			margin: 0 auto;
			display: flex;
			align-items: center;
			justify-content: space-between;

			img {
				max-width: 100%;
				max-height: 100%;
			}
		}
	}

	@media (max-width: 768px) {
		.spotlight-wrap {
			flex-direction: column;

			.left {
				text-align: center;
				width: 100% !important;
			}
		}
		
		.viewport {
			min-height: 387px !important;
		}
		
		.introduction-item {
			flex-direction: column;
			margin: 24px 0;

			.left {
				text-align: center;
				width: 100% !important;
			}
		}
	}
</style>